import { render, staticRenderFns } from "./companyAgreement.vue?vue&type=template&id=5fe04dd1&scoped=true"
import script from "./companyAgreement.vue?vue&type=script&lang=js"
export * from "./companyAgreement.vue?vue&type=script&lang=js"
import style0 from "./companyAgreement.vue?vue&type=style&index=0&id=5fe04dd1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe04dd1",
  null
  
)

export default component.exports